import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 7C8 4.79086 9.79086 3 12 3C13.6387 3 15.0494 3.98556 15.6676 5.40037C15.7243 5.53006 15.7742 5.66329 15.817 5.79965L16.1167 6.7537L18.0248 6.1544L17.7251 5.20035C17.6607 4.99511 17.5855 4.79465 17.5003 4.59963C16.5754 2.48263 14.4619 1 12 1C8.68629 1 6 3.68629 6 7V10H3.5V22H20.5V10H8V7ZM15 15V17H9V15H15Z"}}]};

const LockOffFilled = Vue.extend<IconProps>({
  name: 'LockOffFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'lock-off-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LockOffFilled;
